export const SETTING_ACCESSIBILITY_CHANGED_EVENT = "DevOwl/Customize/Setting/AccessibilityChanged";
